import { IconButton } from '@trackman/web-shared-components';
import './ArrowNavigationButton.scss';
import { ReactComponent as ChevronLeft } from 'images/icons/ChevronLeftThin.svg';

export const ArrowNavigationButton = ({
  direction,
  disabled,
  onClick,
}: {
  direction: 'prev' | 'next';
  disabled?: boolean;
  onClick: () => void;
}) => {
  return (
    <IconButton
      icon={() => <ChevronLeft />}
      className={`arrow-navigation-button ${direction === 'next' ? 'arrow-navigation-button--next' : ''}`}
      onClick={onClick}
      disabled={disabled}
    ></IconButton>
  );
};
